import { ErrorBox } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { Card, Title, Explanation } from "./StyledComponents";

const i18nBase = "demand.trends.anomaly.agent.error.";

const DemandTrendsAnomalyAgentError = () => (
    <Card data-automation="demand-spike-agent-error">
        <Stack
            gap="8px"
            alignItems="center"
        >
            <ErrorBox
                size="lg"
                color={colorsPalettes.red[400]}
            />
            <Title>{translate(`${i18nBase}title`)}</Title>
            <Explanation>{translate(`${i18nBase}description`)}</Explanation>
        </Stack>
    </Card>
);

export default DemandTrendsAnomalyAgentError;
